export const TEMPLATE_TYPE_OPTIONS = [
  { key: 'theme', text: 'Theme', value: 'theme' },
  { key: 'effect', text: 'Effect', value: 'effect' },
];
